function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "db5utzuq0a",
  d: "M2.781 0c.03 0 .058.02.068.05l7.81 23.807c.023.066.114.067.136 0L18.711.05c.01-.03.037-.05.067-.05h1.751c.03 0 .058.02.068.05l7.864 23.805c.022.067.113.067.135 0L36.353.051c.01-.03.037-.051.068-.051h2.707c.05 0 .085.05.068.1l-9.22 27.05c-.01.03-.038.05-.068.05h-2.762c-.03 0-.056-.02-.067-.048l-4.22-11.844-3.11-10.347c-.022-.07-.116-.07-.138-.001l-3.215 10.402-4.221 11.79c-.01.029-.038.048-.068.048H9.345c-.03 0-.057-.02-.067-.05L.004.1C-.012.05.022 0 .072 0h2.71z"
}), /*#__PURE__*/React.createElement("path", {
  id: "wj2iz8g61c",
  d: "M13.738 0C21.33 0 28.103 4.654 27.1 15.223c-.003.039-.036.07-.075.07H2.82c-.045 0-.08.04-.076.084.581 6.301 5.395 9.95 10.921 9.982.04 0 .073.029.073.069v2.5c0 .041-.035.072-.077.072C6.09 27.965 0 22.634 0 14.027 0 5.887 6.13 0 13.738 0zm0 2.475c-5.559 0-10.357 3.764-10.994 10.367-.004.045.032.085.076.085h21.789c.042 0 .076-.036.076-.078-.089-6.663-4.459-10.374-10.947-10.374z"
}), /*#__PURE__*/React.createElement("path", {
  id: "hjkddkrnve",
  d: "M27.126 0c.04 0 .074.033.074.074v37.818c0 .04-.033.073-.074.073h-2.459c-.04 0-.073-.032-.073-.073v-5.57c0-.074-.095-.098-.132-.033-2.264 3.92-6.58 6.111-11.052 6.111C5.917 38.4 0 33.463 0 24.569c0-8.841 5.972-13.83 13.463-13.83 4.522 0 8.783 1.875 10.997 6.032.036.067.134.046.134-.03V.074c0-.041.033-.074.073-.074h2.46zM13.571 13.288c-6.025 0-10.965 3.743-10.965 11.281 0 7.43 4.94 11.226 10.965 11.226 6.299 0 10.968-4.608 10.968-11.279 0-6.673-4.78-11.228-10.968-11.228z"
}), /*#__PURE__*/React.createElement("path", {
  id: "nohdx8hbbg",
  d: "M28.148 0C34.608 0 39.2 4.586 39.2 11.223v15.904c0 .04-.033.073-.072.073h-2.47c-.041 0-.073-.033-.073-.073V11.223c0-5.126-3.417-8.742-8.437-8.742s-8.49 3.78-8.49 8.905v15.741c0 .04-.033.073-.073.073h-2.47c-.04 0-.072-.033-.072-.073v-15.74c0-5.127-3.472-8.851-8.491-8.851C2.77 2.536.664 7.909.14 9.616c-.025.08-.141.06-.141-.023l.008-4.61c0-.013.004-.025.01-.036C1.836 1.452 5.193 0 8.605 0c3.953 0 8.116 1.788 9.71 6.402.022.063.104.065.128.003C20.092 2.153 24.145 0 28.148 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "xo47s4y62i",
  d: "M13.738 0C21.33 0 28.103 4.654 27.1 15.224c-.004.038-.037.07-.075.07H2.819c-.044 0-.079.04-.075.083.581 6.302 5.395 9.952 10.921 9.983.04.001.073.033.073.073v2.19c0 .278-.104.379-.229.377C6.008 27.894 0 22.578 0 14.028 0 5.887 6.13 0 13.738 0zm0 2.475C8.18 2.475 3.38 6.24 2.744 12.844c-.004.044.031.084.076.084h21.789c.042 0 .076-.036.076-.078-.089-6.664-4.46-10.375-10.947-10.375z"
}), /*#__PURE__*/React.createElement("path", {
  id: "serbwtv5tk",
  d: "M27.2 3.66L7.362 36.8S-6.212 22.421 3.502 7.357c0 0 9.05-13.711 23.698-3.697z"
}), /*#__PURE__*/React.createElement("path", {
  id: "zpfx234eam",
  d: "M24.804 0L36.8 0.008 6.783 51.2 0 42.301z"
}), /*#__PURE__*/React.createElement("path", {
  id: "nyaivmmb2o",
  d: "M24.804 0L36.8 0.008 6.783 51.2 0 42.22z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-95 -68) translate(95 68) translate(84.8 14.4) translate(0 10.4)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "aowuj284hb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#db5utzuq0a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#B3D2CC",
  d: "M0.2 -4L43.2 -4 43.2 27 0.2 27z",
  mask: "url(#aowuj284hb)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-95 -68) translate(95 68) translate(84.8 14.4) translate(42.4 10.4)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "e5yvsqxqhd",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#wj2iz8g61c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#B3D2CC",
  d: "M-4 -4L31.2 -4 31.2 32 -4 32z",
  mask: "url(#e5yvsqxqhd)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-95 -68) translate(95 68) translate(84.8 14.4) translate(75.2)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "skiylaxz5f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#hjkddkrnve"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#B3D2CC",
  d: "M-4 -4L31.2 -4 31.2 42.4 -4 42.4z",
  mask: "url(#skiylaxz5f)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-95 -68) translate(95 68) translate(84.8 14.4) translate(110.4 10.4)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "qmf4iufzvh",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#nohdx8hbbg"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#B3D2CC",
  d: "M-4 -4L43.2 -4 43.2 31.2 -4 31.2z",
  mask: "url(#qmf4iufzvh)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-95 -68) translate(95 68) translate(84.8 14.4) translate(155.2 10.4)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "oxvife285j",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#xo47s4y62i"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#B3D2CC",
  d: "M-4 -4L31.2 -4 31.2 32 -4 32z",
  mask: "url(#oxvife285j)"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-95 -68) translate(95 68)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "9jsj6bo3xl",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#serbwtv5tk"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#B3D2CC",
  d: "M-4 -4L31.2 -4 31.2 40.8 -4 40.8z",
  mask: "url(#9jsj6bo3xl)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-95 -68) translate(95 68) translate(12 .8)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "dyqsncin3n",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#zpfx234eam"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#B3D2CC",
  d: "M-4 -4L40.8 -4 40.8 55.2 -4 55.2z",
  mask: "url(#dyqsncin3n)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-95 -68) translate(95 68) translate(24 16)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "u67ukw8eyp",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#nyaivmmb2o"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#B3D2CC",
  d: "M-4 -4L40.8 -4 40.8 55.2 -4 55.2z",
  mask: "url(#u67ukw8eyp)"
}))), /*#__PURE__*/React.createElement("text", {
  fill: "#B3D2CC",
  fontFamily: "Gilroy-Bold, Gilroy",
  fontSize: 16,
  fontWeight: "bold",
  transform: "translate(-95 -68) translate(95 68)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 210.444,
  y: 74
}, "Wishlist")))));

function SvgWedmeLogotypeAGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 268,
    height: 75,
    viewBox: "0 0 268 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWedmeLogotypeAGreen);
export default __webpack_public_path__ + "static/media/wedme-logotype-a-green.ed63174d.svg";
export { ForwardRef as ReactComponent };